exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol li[data-v-cb4b8f6a]::marker{font-weight:400}li[data-v-cb4b8f6a]{font-weight:300}.text-h6[data-v-cb4b8f6a]{font-size:.85rem!important;margin:0;padding:0;font-family:ABCFavorit!important}.v-card__text[data-v-cb4b8f6a]{margin:0!important;padding:0!important}@media (min-width:1024px){.lg_hidden[data-v-cb4b8f6a]{display:none}}", ""]);

// exports
